import { render } from "./KontaktPthGjakova.vue?vue&type=template&id=013514cc"
import script from "./KontaktPthGjakova.vue?vue&type=script&lang=js"
export * from "./KontaktPthGjakova.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__